// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"styles_sub-title__3MOYJ"};